import { render, staticRenderFns } from "./FileFilters.vue?vue&type=template&id=4f80e8a0"
import script from "./FileFilters.vue?vue&type=script&lang=js"
export * from "./FileFilters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports